import { TileType } from '@varo/graphql-schema-types';
import discoverMoreTile from 'features/home/HomeScreen/adapters/discoverMoreTile/discoverMoreTile';
import sdVerticalStackContainerTile from 'features/home/HomeScreen/adapters/sdVerticalStackContainerTile/sdVerticalStackContainerTile';
import vxlCardGroupTile from 'features/home/HomeScreen/adapters/vxlCardGroupTile/vxlCardGroupTile';

import { TileAdapterMap } from './types';

const groupAdapterMap: TileAdapterMap = {
  [TileType.VxlCardGroupTile]: vxlCardGroupTile,
  [TileType.SdVerticalStackContainerTile]: sdVerticalStackContainerTile,
  [TileType.VxlCardGroupDiscoverMoreTile]: discoverMoreTile,
};

export default groupAdapterMap;
